// extracted by mini-css-extract-plugin
export var centerText = "_6q-8";
export var container = "_6q-0";
export var doughnutContainer = "_6q-7";
export var legend = "_6q-a";
export var legendItemColorDisplay = "_6q-b";
export var legendItemLabel = "_6q-d";
export var legendItemValue = "_6q-c";
export var lg = "_6q-5";
export var maxWidth = "_6q-9";
export var md = "_6q-4";
export var responsive = "_6q-6";
export var sm = "_6q-3";
export var xs = "_6q-2";
export var xxs = "_6q-1";